import { getAuth } from "firebase/auth";
import { errorNotification } from "../../Generic/Notifications";

export function LogoutUser() {
	const auth = getAuth();
	auth.signOut()
		.then(function () {
			//Clear all polling functions
			var id = window.setTimeout(function () {}, 0);
			while (id--) {
				window.clearTimeout(id); // will do nothing if no timeout with id is present
			}
			//To reset the redux store back to its initial state after logout
			//reload method takes an optional parameter which by default is set to false. If set to true, the browser will do a complete page refresh from the server and not from the cached version of the page.
			window.location.reload(false);
		})
		.catch(function (error) {
			errorNotification("Could not Log Out");
		});
}

export function getAccessToken(forceRefresh) {
	const auth = getAuth();
	//Returns the current token if not expired or else will give a new token
	return auth.currentUser.getIdToken(forceRefresh);
}
